module.exports = __webpack_public_path__ + "img/ASO_fr4.83e7d19f.png";